import React from 'react';
import { Users, ScanLine, History, RefreshCw, Settings } from 'lucide-react';
export type TabId = 'employees' | 'scan' | 'history' | 'sync' | 'settings';
interface BottomNavProps {
  activeTab: TabId;
  onTabChange: (tab: TabId) => void;
}
export function BottomNav({
  activeTab,
  onTabChange
}: BottomNavProps) {
  const tabs = [{
    id: 'employees',
    label: 'Employees',
    icon: Users
  }, {
    id: 'scan',
    label: 'Scan',
    icon: ScanLine
  }, {
    id: 'history',
    label: 'History',
    icon: History
  }, {
    id: 'sync',
    label: 'Sync',
    icon: RefreshCw
  }, {
    id: 'settings',
    label: 'Settings',
    icon: Settings
  }] as const;
  return <nav className="bg-slate-800 border-t border-slate-700 pb-safe pt-2 px-2" data-id="element-26">
      <div className="flex justify-around items-center" data-id="element-27">
        {tabs.map(tab => {
        const isActive = activeTab === tab.id;
        const Icon = tab.icon;
        return <button key={tab.id} onClick={() => onTabChange(tab.id)} className={`flex flex-col items-center justify-center p-2 min-w-[64px] rounded-lg transition-colors ${isActive ? 'text-blue-400 bg-blue-500/10' : 'text-slate-400 hover:text-slate-200 hover:bg-slate-700/50'}`} data-id="element-28">
              <Icon size={24} strokeWidth={isActive ? 2.5 : 2} data-id="element-29" />
              <span className={`text-[10px] mt-1 font-medium ${isActive ? 'text-blue-400' : 'text-slate-500'}`} data-id="element-30">
                {tab.label}
              </span>
            </button>;
      })}
      </div>
    </nav>;
}